import "../SignupCL/SignupCL.css";
import { Link, useNavigate } from "react-router-dom";
import { missingPopup } from "../../../helpers/dataHelper/missingData";
import { clearMultiCommunityState } from "../../../redux/multicommunity/multicommunity";
import {
  setLoading,
  setResponseLoading,
} from "../../../redux/loading/loadingSlice";
import { storeUser } from "../../../redux/users/usersSlice";
import { toastify } from "../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import eye from "../../../assets/images/eye.svg";
import eyeBlock from "../../../assets/images/eye-block.svg";
import FloatingTextFiled from "../../../pages/sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import React, { useEffect, useState } from "react";
import useApi from "../../../helpers/apiHelper/requestHelper";
import {
  redirectToBinanceOAuth,
  redirectToBybitOAuth,
} from "../../../helpers/exchangeOAuth";
import validator from "validator";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { fetchUser } from "../../../helpers/helper";
import { socailSignUp } from "../../../redux/socialSignup/socialSignUp";
import Bybit from "../../../assets/images/onboardingImages/bybit.svg";
import Binance from "../../../assets/images/onboardingImages/binance.svg";
import Discord from "../../../assets/images/onboardingImages/discord.svg";
import Telegram from "../../../assets/images/onboardingImages/telegram.svg";

const ENV = window.location.hostname.split(".")[0] === "my" ? "prod" : "dev";

const PASSWORD_RULES = {
  DIGIT: /[0-9]/,
  MIN_LENGTH: 8,
  SPECIAL: /[!@#$%^&*()_+{}[\]:;<>,.?~-]/,
  UPPERCASE: /[A-Z]/,
};

const SignupMemberNoLink = () => {
  const [isSignUpPage, setIsSignUpPage] = useState(true);
  const { user } = useSelector((state) => state.user);
  const socialSignUp = useSelector((state) => state?.socialSignUp?.value);

  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");

  const handlePasswordChange = (value) => {
    const newPassword = value;

    setData((prevState) => ({
      ...prevState,
      password: newPassword,
    }));

    if (!newPassword) {
      setValidationMessage("");
      return;
    }

    const validations = [
      {
        message: "Password must contain at least one digit",
        test: PASSWORD_RULES.DIGIT.test(newPassword),
      },
      {
        message: "Password must contain at least one special character",
        test: PASSWORD_RULES.SPECIAL.test(newPassword),
      },
      {
        message: "Password must contain at least one uppercase letter",
        test: PASSWORD_RULES.UPPERCASE.test(newPassword),
      },
      {
        message: `Password must be at least ${PASSWORD_RULES.MIN_LENGTH} characters long`,
        test: validator.isLength(newPassword, {
          min: PASSWORD_RULES.MIN_LENGTH,
        }),
      },
    ];

    const failedValidation = validations.find((v) => !v.test);
    setValidationMessage(failedValidation ? failedValidation.message : "");
  };

  const handleSignup = async () => {
    try {
      if (!data.email) return missingPopup("Email");
      if (!data.password) return missingPopup("Password");

      if (!/\S+@\S+\.\S+/.test(data.email))
        return toastify("Please enter a valid email address", "error");
      if (validationMessage) return toastify(validationMessage, "error");

      dispatch(setLoading(true));

      const response = await api(
        "post",
        `NoLinkMember/${isSignUpPage ? "signup" : "login"}`,
        data
      );

      if (response?.status) {
        dispatch(clearMultiCommunityState());
        const role = response?.data.user.role;
        localStorage.setItem("token", response?.data?.token);
        await fetchUser(api, dispatch, storeUser);
        setTimeout(() => {
          // dispatch(setLoading(false));
          navigate(`/cmWithNoLink/dashboard`, { replace: true });
        }, 1500);
      } else {
        setTimeout(() => {
          dispatch(setLoading(false));
          toastify(response?.message);
        }, 1500);
      }
    } catch (error) {
      console.error("🚀 -> handleSignup -> error:", error);
    }
  };

  const binanceButtonClick = () => {
    if (ENV !== "prod") {
      toastify("Binance Login Not Available on Dev", "success");
      return;
    }

    redirectToBinanceOAuth({ allowSocialLogin: true, memberNoLink: true });
  };

  const byBitButtonClick = async () => {
    if (ENV !== "prod") {
      toastify("Bybit Login Not Available on Dev", "success");
      return;
    }

    redirectToBybitOAuth({ allowSocialLogin: true, memberNoLink: true });
  };

  const loginWithDiscord = async () => {
    const stateData = {
      // To assigns member role as memberNoLink
      memberNoLink: true,
    };

    const encodedState = btoa(JSON.stringify(stateData));

    const discordOAuthURL = `${process.env.REACT_APP_DISCORD_OAUTH_URL}&state=${encodedState}`;

    window.location.href = discordOAuthURL;
  };

  const telegramRedirectUrl = () => {
    dispatch(
      socailSignUp({
        community: null,
        // To assigns member role as memberNoLink
        memberNoLink: true,
      })
    );

    const telegramOAuthURL = process.env.REACT_APP_TELEGRAM_OAUTH_URL;
    window.location.href = telegramOAuthURL;
  };

  const loginWithTelegram = async (data) => {
    dispatch(setLoading(true));

    const response = await api("post", "fastSignupLogin/Telegram", {
      telegramRes: data,
      community: socialSignUp?.community,
    });

    if (response?.status) {
      const { data } = response || {};
      const { user, token } = data || {};

      if (!user) return;

      dispatch(storeUser(data));
      localStorage.setItem("token", token);

      setTimeout(() => {
        dispatch(setLoading(false));
        navigate(`/cmWithNoLink/dashboard`);
      }, 1500);
    }
  };

  useEffect(() => {
    const handleTelegramAuth = () => {
      const hash = window.location.hash;

      if (!hash || !hash.includes("tgAuthResult=")) return;
      dispatch(setLoading(true));

      try {
        const base64Data = hash.split("tgAuthResult=")[1];
        const decodedData = decodeURIComponent(atob(base64Data));
        const telegramData = JSON.parse(decodedData);

        loginWithTelegram(telegramData);
        window.history.replaceState(null, null, window.location.pathname);
      } catch (error) {
        console.error("🚀 -> handleTelegramAuth -> error:", error);
      }
    };

    handleTelegramAuth();
  }, []);

  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("code")) return;

    localStorage.removeItem("AllowSocialLogin");
    dispatch(setLoading(false));
    dispatch(setResponseLoading(false));
  }, []);

  return (
    <div className="onboardinLayout">
      <div className="onboardingCard">
        <div className="onboardingCardTopBox">
          <p
            className="loginTopLeft"
            onClick={() => {
              navigate(`/login`);
            }}
          >
            {"Login as Leader | Member"}
          </p>
        </div>
        <div className="onboardingCardContentBox">
          <div className="headingBox withHeight">
            <h2 className="title">{`${
              isSignUpPage
                ? "Create an account as a No Link Member"
                : "Log in as No Link Member"
            }`}</h2>
            <p className="subText">
              {`${
                isSignUpPage
                  ? "Submit email and a strong password"
                  : "Did you use your email to create a user?"
              }`}
            </p>
          </div>
          <div className="inputBox">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.email ? "filled" : ""}`}
              forLabel="Email"
              label="Email"
              onChange={(e) =>
                setData((pre) => ({ ...pre, email: e.target.value }))
              }
              placeholder="Email"
              type="email"
              value={data.email}
            />
          </div>
          <div className="inputBox password">
            <FloatingTextFiled
              className={`onboardingInput loginSignUpInput ${data.password ? "filled" : ""}`}
              forLabel="Password"
              label="Password"
              onChange={(e) => {
                handlePasswordChange(e.target.value);
              }}
              placeholder="Password"
              type={showPassword ? "text" : "Password"}
              value={data.password}
            />
            <button
              className={`eyebtn ${showPassword && "view"}`}
              onClick={() => {
                setShowPassword((pre) => !pre);
              }}
              type="button"
            >
              <img alt="" src={showPassword ? eye : eyeBlock} />
            </button>
          </div>
          <BubbleSvgButton
            onClick={handleSignup}
            text={`${isSignUpPage ? "Sign up with email" : "Log in"}`}
            type="button"
            variant="green"
            containerStyling={{
              justifyContent: "center",
            }}
          />
          {/* in-progress */}
          {/* <div className="orBox">
            <p className="orText noBorder">
              Or did you sign up with a social account?
            </p>
          </div>
          <div className="fasterLoginBox">
            <button
              className="fasterLoginBtn"
              onClick={telegramRedirectUrl}
              type="button"
            >
              <img alt="" src={Telegram} />
            </button>

            <button
              className="fasterLoginBtn"
              onClick={loginWithDiscord}
              type="button"
            >
              <img alt="" src={Discord} />
            </button>

            <button
              className="fasterLoginBtn"
              onClick={binanceButtonClick}
              type="button"
            >
              <img alt="" src={Binance} />
            </button>
            <button
              className="fasterLoginBtn"
              onClick={byBitButtonClick}
              type="button"
            >
              <img alt="" src={Bybit} />
            </button>
          </div> */}

          {isSignUpPage && (
            <div className="privacyContentBox">
              <p>
                By continuing, you agree to accept our <br />
                <Link to="http://copyyy.it/privacy-policies">
                  Privacy Policy
                </Link>{" "}
                &{" "}
                <Link to="http://copyyy.it/terms-and-conditions">
                  Terms of Service
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SignupMemberNoLink;
